import React, {Component} from "react"
import $ from "jquery"
import {
  COGO_TRAINING_NO_OF_CYCLES_PER_SESSION,
  COGOLAND_ACTIVITY_TYPE_DESC,
  COGOLAND_SESSION_DATE_FORMAT, convertSessionIndexToX
} from "../../../../constants"
import {convertToDisplayFormat} from "../../../../util/DateUtil"
import {injectIntl} from "react-intl"
import {findActivityType} from "../../../cogoland/component/CogoLandSessionsTable"
import formatDuration from "format-duration"

const tableId = 'CogolandSessionTable'

class CogolandSessionTable extends Component {

  constructor() {
    super()
    this.state = {isPVT: false}
  }

  componentDidMount() {

    const tableName = this.props.name
    const table = $('#' + tableId + tableName).DataTable({
      data: [],
      ordering: false,
      pageLength: 100,
      dom: 't'
    })
  }

  componentWillReceiveProps(nextProps) {

    const tableName = this.props.name
    const isPVT = findActivityType(nextProps.data, 'PVT')
    this.setState({isPVT: isPVT})

    const formatNumber = this.props.intl.formatNumber
    const formatMessage = this.props.intl.formatMessage

    const avg = (col)=>{
      if(!col || col.length === 0) return 0
      else return Math.round(_.sum(col)/col.length)
    }

    const data = []
    const sessions = _.sortBy(nextProps.data, 'index')

    sessions.filter(it=>it.status !== 'NOT_STARTED').forEach((it) => {

      let activities = _.sortBy(it.activities, 'index')

      activities.forEach(a=>{
        const mcqScore = a.mcqScore
        data.push([
          convertSessionIndexToX(it.index),
          formatMessage({id:`cogoland.activity.type.${a.type.name}`}),
          convertToDisplayFormat(a.dateTimeCompleted, COGOLAND_SESSION_DATE_FORMAT),
          a.averageThreshold?_.round(a.averageThreshold):'-',
          a.averageAttention?_.round(a.averageAttention):'-',
          a.longestAttentionSpan?_.isString(a.longestAttentionSpan)?a.longestAttentionSpan:formatDuration(_.round(a.longestAttentionSpan)*1000, {leading: true}):'-',
          mcqScore>0?`${_.round(mcqScore*100/20)}% (${mcqScore}/20)`:'-',
          a.overallAverageReactionTime?formatNumber(a.overallAverageReactionTime):'-',
          a.overallAverageAccuracy?formatNumber(a.overallAverageAccuracy):'-'
        ])
      })
    })
    let table = $('#' + tableId + tableName).DataTable()
    table.column(3).visible(false);
    if(isPVT){
      table.column(6).visible(false);
      table.column(7).visible(true);
      table.column(8).visible(true);
    }else{
      table.column(6).visible(true);
      table.column(7).visible(false);
      table.column(8).visible(false);
    }
    table.clear()
    table.rows.add(data).draw()
  }

  render() {

    const tableName = this.props.name
    const format = this.props.intl.formatMessage
    const isPVT = findActivityType(this.props.data, 'PVT')

    return (
      <table width="100%"
             className="display responsive table table-striped table-bordered table-hover dataTables-example"
             id={tableId+tableName}>
        <thead>
        <tr>
          <th className={"text-center"}>{format({id: 'cogoland.session.no'})}</th>
          <th className={"text-center"}>{format({id: 'cogoland.activity.type'})}</th>
          <th className={"text-center"}>{format({id: 'cogoland.activity.completed.date'})}</th>
          <th className={"text-center"}>{format({id: 'cogoland.activity.attention.baseline'})}</th>
          <th className={"text-center"}>{format({id: 'cogoland.activity.average.attention'})} (%)</th>
          <th className={"text-center"}>{format({id: 'cogoland.activity.longest.attention.span.achieved'})} (mm:ss)</th>
          <th className={"text-center"}>{format({id: 'cogoland.activity.quiz.result'})}</th>
          <th className={"text-center"}>{format({id: 'cogoland.activity.reaction.time'})}</th>
          <th className={"text-center"}>{format({id: 'cogoland.activity.accuracy'})}</th>
        </tr>
        </thead>
        <tbody>
        </tbody>
      </table>
    )
  }
}

export default injectIntl(CogolandSessionTable)



// WEBPACK FOOTER //
// ./src/routes/enterprise/dashboard/components/CogolandSessionTable.js